if(!customElements.get('variant-swatch-selector')){
    class VariantSwatchSelector extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.section = this.closest('section-product-card');
            this.productCard = this.closest('.product-card');
            this.inputs = this.querySelectorAll('.product-card__input');
            this.imageWrapper = this.productCard.querySelector('.product-card__image-wrapper > a');
            
            this.inputs.forEach(item => {
                const groupRadios = item.querySelectorAll('input[type="radio"]');
                groupRadios.forEach(radio => {
                    if(radio.checked){
                        radio.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                    radio.addEventListener("change", e => {
                        const selectedOption = item.querySelector('input[type="radio"]:checked');
                        this.updateValue({ e, target: selectedOption, selectedOptionValues: this.selectedOptionValues });
                    });

                    const label = this.querySelector(`label[for="${radio.id}"]`);
                    if(label){
                        label.addEventListener("click", e => {
                            if(radio.getAttribute('disabled') !== null) return;
                            radio.checked = !radio.checked;

                            if(radio.checked){
                                const selectedOption = item.querySelector('input[type="radio"]:checked');
                                this.updateValue({ e, target: selectedOption, selectedOptionValues: this.selectedOptionValues });
                            }
                        });
                        label.addEventListener('keydown', e => {
                            if(e.key === 'Enter'){
                                radio.checked = true;
                                const selectedOption = item.querySelector('input[type="radio"]:checked');
                                this.updateValue({ e, target: selectedOption, selectedOptionValues: this.selectedOptionValues });
                            }
                        });
                    }
                });
            });
        }

        loadCheckedRadioInput(){
            this.inputs.forEach(item => {
                const groupRadios = item.querySelectorAll('input[type="radio"]');

                groupRadios.forEach(radio => {
                    if(radio.checked){
                        radio.dispatchEvent(new Event('change', { bubbles: true }));
                    }else if(radio.getAttribute('checked') == ''){
                        radio.checked = true;
                        radio.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });
            });
        }

        updateValue({e = null, target = null, selectedOptionValues = null, source = null}){
            if (!this.contains(e.target)) return;

            const productUrl = target.dataset.productUrl || this.pendingRequestUrl || url;
            const productId = target.dataset.optionValueId;
            this.pendingRequestUrl = productUrl;

            this.renderProductInfo({
                requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues),
                targetId: productId,
                callback: this.updateProductInfo()
            });
        }

        updateProductInfo(){
            return(html) => {
                const selectedVariantJsonData = JSON.parse(html.querySelector('#json-selected-variant').textContent);
                const media = selectedVariantJsonData.featured_media;

                this.updateMedia(media, selectedVariantJsonData.name);
                this.updateContent(html);
                this.updateOptionAvailability(html);

                // Only show a variant price / add a specific variant when the card's
                // pickers cover every option; otherwise keep the "From" price and popup.
                if(this.productCard.dataset.variantOnCard === 'true'){
                    this.updatePrice(html);
                    this.updateStock(html);
                    this.updateProductForm(html);
                }
            }
        }

        buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false){
            const params = [];

            const sectionId = this.productCard?.dataset.layout === 'horizontal' ? 'product-card-horizontal' : 'product-card';
            !shouldFetchFullPage && params.push(`section_id=${sectionId}`);
            if(optionValues.length) {
                params.push(`option_values=${optionValues.join(',')}`);
            }
            if(url.includes('?')) return `${url}&${params.join('&')}`;
            return `${url}?${params.join('&')}`;
        }

        get selectedOptionValues() {
            // Swatch and pill pickers are separate elements; send the whole card's selection.
            return Array.from(this.productCard.querySelectorAll('variant-swatch-selector fieldset input:checked')).map(
                ({ dataset }) => dataset.optionValueId
            );
        }

        renderProductInfo({ requestUrl, targetId, callback }){
            this.abortController?.abort();
            this.abortController = new AbortController();

            fetch(requestUrl, { signal: this.abortController.signal })
                .then(res => res.text())
                .then(resText => {
                    this.pendingRequestUrl = null;
                    const html = new DOMParser().parseFromString(resText, 'text/html');
                    callback(html);
                })
                .catch(error => {
                    if(error.name === 'AbortError') {
                        console.log('Fetch aborted by user');
                    }else{
                        console.error(error);
                    }
                });
        }

        updateMedia(media = null, variantName = ''){
            if(!media){
                const selectedVariantImage = this.productCard.querySelector('.selected-variant-image');
                if(selectedVariantImage){
                    selectedVariantImage.remove();
                }
                return;
            }

            const mediaURL = media.preview_image?.src;
            if(mediaURL){
                const newDiv = document.createElement('div');
                const newImg = document.createElement("img");
                newImg.src = `${mediaURL}?width=500`;
                newImg.alt = variantName;

                newDiv.classList.add('selected-variant-image', 'w-100', 'h-100', 'position-absolute', 'top-0', 'left-0', 'product-media-fade-in');
                newImg.classList.add('object-cover', 'w-100', 'h-100');

                newDiv.appendChild(newImg);
                this.imageWrapper.appendChild(newDiv);

                setTimeout(() => {
                    this.imageWrapper.querySelectorAll('.product-media-fade-in').forEach(item => {
                        item.classList.add('in-view');
                    })
                }, 100);
            }
        }

        updatePrice(html){
            const newPriceHTML = html.querySelector(".price");
            const oldPrice = this.productCard.querySelector(".price");

            if(newPriceHTML && oldPrice && oldPrice.parentNode){
                oldPrice.parentNode.replaceChild(newPriceHTML.cloneNode(true), oldPrice);
            }
        }

        // Same rule as snippets/product-card.liquid: "nicht auf Lager" always shows,
        // "auf Lager" only when the card's section has show_stock on.
        updateStock(html){
            const newStock = html.querySelector(".product-card__stock-source .product-card__stock");
            const footer = this.productCard.querySelector(".product-card__footer");
            if(!newStock || !footer) return;

            const oldStock = footer.querySelector(".product-card__stock");
            const inStock = newStock.querySelector(".product-card__stock-dot--in") !== null;
            const showRow = !inStock || this.productCard.dataset.showStock === 'true';

            if(!showRow){
                oldStock?.remove();
            }else if(oldStock){
                oldStock.replaceWith(newStock.cloneNode(true));
            }else{
                footer.prepend(newStock.cloneNode(true));
            }
        }

        updateContent(html){
            const newContentHTML = html.querySelector(".product-card__content");
            const oldContent = this.productCard.querySelector(".product-card__content");

            if(newContentHTML){
                if(oldContent && oldContent.parentNode){
                    oldContent.parentNode.replaceChild(newContentHTML.cloneNode(true), oldContent);
                }else{
                    const price = this.productCard.querySelector(".price");
                    if(price && price.parentNode){
                        price.parentNode.insertBefore(newContentHTML.cloneNode(true), price);
                    }
                }
            }else if(oldContent){
                oldContent.remove();
            }
        }

        updateOptionAvailability(html){
            const source = html.querySelector('.product-card__option-availability');
            if(!source) return;

            this.productCard.querySelectorAll('variant-swatch-selector input[data-option-value-id]').forEach(input => {
                const match = source.querySelector(`input[data-option-value-id="${input.dataset.optionValueId}"]`);
                if(match) input.disabled = match.disabled;
            });
        }

        // Swaps the add to cart button, or the disabled "Ausverkauft" button for a sold-out
        // variant, see snippets/product-card-cart-cta.liquid.
        updateProductForm(html){
            const newCta = html.querySelector("[data-card-cart-cta]");
            const oldCta = this.productCard.querySelector("[data-card-cart-cta]");

            if(newCta && oldCta && oldCta.parentNode){
                oldCta.parentNode.replaceChild(newCta.cloneNode(true), oldCta);
            }
        }
    }

    customElements.define('variant-swatch-selector', VariantSwatchSelector);
} 